var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSort(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.0800781,
    width: 24,
    height: 24,
    rx: 3,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.7017 19.9201C16.8216 19.97 16.9416 19.99 17.0815 20L17.0805 19.989C17.2104 19.979 17.3303 19.959 17.4603 19.9091C17.5802 19.8591 17.6901 19.7891 17.7901 19.6992L21.7877 15.7017C22.1775 15.3019 22.1775 14.6723 21.7877 14.2826C21.388 13.8838 20.7583 13.8838 20.3686 14.2836L18.0799 16.5821V4.99938C18.0799 4.43972 17.6302 4 17.0805 4C16.5208 4 16.0811 4.43972 16.0811 4.99938V16.5911L13.7924 14.2926C13.3926 13.8938 12.763 13.8938 12.3732 14.2936C11.9745 14.6833 11.9745 15.3129 12.3742 15.7127L16.3719 19.7102C16.4618 19.8001 16.5718 19.8701 16.7017 19.9201ZM6.08775 19.0004C6.08775 19.5501 6.52749 19.9998 7.08717 19.9998C7.63685 19.9998 8.08659 19.5501 8.08659 19.0004V7.41764L10.3753 9.7162C10.765 10.106 11.3947 10.106 11.7944 9.7162C12.1842 9.31645 12.1842 8.68684 11.7944 8.29709L7.79676 4.29958C7.69681 4.19965 7.58688 4.12969 7.46695 4.08972C7.33702 4.02975 7.21709 4.00977 7.08717 4.00977C6.94725 4.00977 6.82732 4.02975 6.70739 4.08972C6.57746 4.12969 6.46753 4.19965 6.37758 4.29958L2.3799 8.29709C1.98014 8.68684 1.98014 9.31645 2.3799 9.7162C2.76968 10.106 3.39931 10.106 3.79908 9.7162L6.08775 7.41764V19.0004Z",
    fill: "#51597B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSort);
export default __webpack_public_path__ + "static/media/sort.1be64d9c2310bb7c1eca93f3924aae05.svg";
export { ForwardRef as ReactComponent };